import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useGetHelpCenterArticleBreacrumbs} from '../hooks/useGetHelpCenterArticle';
import {HelpCenterMobileNavigation} from '../shared/HelpCenterMobileNavigation';
import {LoadingPlaceholder} from './LoadingPlaceholder';

export const HelpCenterArticleNavigation = () => {
  return (
    <DataFetcher
      request={useGetHelpCenterArticleBreacrumbs()}
      View={HelpCenterMobileNavigation}
      viewProps={{hideTitle: true}}
      Error={() => null}
      Loading={LoadingPlaceholder}
    />
  );
};
